import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation } from '@tanstack/react-query';
import { PackagingRulesetsApiAdapter } from '../adapters/PackagingRulesetsApiAdapter';
import { PackagingEvaluationContext, SimulatorResult } from '../models/PackagingRulesets';

const apiAdapter = new PackagingRulesetsApiAdapter(createHttpClient(apiClientWH));

interface EvaluateRulesetsParams {
  boxRulesetId: number | null;
  marketingRulesetId: number | null;
  context: PackagingEvaluationContext;
}

/** Evaluate: según API solo se envía `context` en el body (sin team_id). */
export const usePackagingSimulator = () => {
  return useMutation({
    mutationFn: async ({
      boxRulesetId,
      marketingRulesetId,
      context,
    }: EvaluateRulesetsParams): Promise<SimulatorResult> => {
      const [boxResult, marketingResult] = await Promise.allSettled([
        boxRulesetId
          ? apiAdapter.evaluateBoxRuleset(boxRulesetId, context)
          : Promise.reject(new Error('no_box_ruleset')),
        marketingRulesetId
          ? apiAdapter.evaluateMarketingRuleset(marketingRulesetId, context)
          : Promise.reject(new Error('no_marketing_ruleset')),
      ]);

      return {
        box: {
          packaging_item_id: boxResult.status === 'fulfilled' ? boxResult.value.packaging_item_id : null,
          error: boxResult.status === 'rejected' ? ((boxResult.reason as Error)?.message ?? 'error') : undefined,
        },
        marketing: {
          items: marketingResult.status === 'fulfilled' ? marketingResult.value.items : [],
          error:
            marketingResult.status === 'rejected' ? ((marketingResult.reason as Error)?.message ?? 'error') : undefined,
        },
      };
    },
  });
};
